const state = {
  data: {},
  validations: [] // php側のバリデーション
}

const mutations = {
  put(state, signData) {
    state.data = signData
  },
  setData(state, data) {
    state.data = data
  },
  remove(state) {
    state.data = null
  },
  // php側のバリデーションエラー更新
  updateValidations(state, validations) {
    state.validations = validations
  }
}

const actions = {
  setData({commit}, data) {
    commit('setData', data)
  },
  // php側のバリデーションエラー更新
  updateValidations({commit}, validations) {
    commit('updateValidations', validations)
  }
}

const getters = {
  data(state) {
    return state.data
  },
  getValidations(state) {
    return state.validations
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
